import {ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation} from '@angular/core';
import {FormControl, FormGroupDirective} from "@angular/forms";
import {DiscountSelection} from "../../../../types";
import {HarbourDuesRotterdamResponse} from "@portbase/bezoekschip-service-typescriptmodels";
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-harbour-dues-exemption',
  templateUrl: './exemption.component.html',
  styleUrls: ['./exemption.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExemptionComponent {
  readonly form = inject(FormGroupDirective);
  readonly exemption = this.form.control.get('exemption') as FormControl;
  readonly exemptionValue = toSignal(
    this.exemption.valueChanges,
    { initialValue: this.exemption.value }
  );
  private readonly selectedType = this.form.control.get('selectedType') as FormControl;
  private readonly selectedTypeValue = toSignal(this.selectedType.valueChanges);
  readonly harbourDuesDetails = input<HarbourDuesRotterdamResponse>();
  readonly formattedExemptionValue = computed(
    () => this.exemptionRotterdamFormatter(this.exemptionValue())
  );
  readonly exemptionSelected = computed(
    () => this.selectedTypeValue() === DiscountSelection.EXEMPTION
  );

  readonly exemptionTypes = computed(
    () => this.harbourDuesDetails()?.lookupExemptionTypes?.map(
      exemption => exemption.exemptionType
    ) as string [] || [],
  )

  exemptionRotterdamFormatter = (exemptionTypeKey: string): string => {
    const exemptionTypes = this.harbourDuesDetails()?.lookupExemptionTypes || [];
    const exemptionType = exemptionTypes.find(
      exemptionType => exemptionType.exemptionType === exemptionTypeKey
    );
    if (!exemptionType) {
      return exemptionTypeKey;
    }
    return [exemptionType?.exemptionType, exemptionType?.description].join(" - ");
  }
}
